import { render } from "./EditInvitationView.vue?vue&type=template&id=1b6408d2&scoped=true"
import script from "./EditInvitationView.vue?vue&type=script&lang=js"
export * from "./EditInvitationView.vue?vue&type=script&lang=js"

import "./EditInvitationView.vue?vue&type=style&index=0&id=1b6408d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b6408d2"]])

export default __exports__